/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFourkitesControl.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/fourkites-control";

export class AutogenModelFourkitesControl<RowType extends ModelRow> extends Endpoint<RowType, RowFourkitesControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFourkitesControl extends ModelRow<RowFourkitesControlFields> {
	constructor(values?: Partial<RowFourkitesControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFourkitesControlFields {
	company_id: string;
	customer_id: string;
	delivered_lookback_time: number;
	email_list: string;
	export_mcnum: string;
	export_override_payee: string;
	export_scac: string;
	id: string;
	is_active: string;
}

